<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommon from './mixin';
import { mapState } from 'vuex';
import { planTypes } from '@/common/constants';
import { get, orderBy } from 'lodash';
import { checkIfMultipleBasePlanDependencies } from '@/plans/ROOM_CONNECTOR/common/utils';

export default {
  name: 'RoomConnectorAddon',
  mixins: [base, planCommon],
  for: ()=> {
    if(checkIfMultipleBasePlanDependencies()) return planTypes.map([ planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE, planTypes.ZOOM_ROOMS ])
    return planTypes.map([ planTypes.ZOOM_ROOMS ]);
  },
  data() {
    return {
      planType: planTypes.ROOM_CONNECTOR,
      description: this.$t('billing.rc.desc'),
    }
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    this.productPlans = this.currentProductPlans;
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    currentProductPlans() {
      return orderBy(
        this.planMapFlat.filter((p) => p.type === this.planType),
        ['amount'],
        'asc',
      );
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
  },
};
</script>
